import React from 'react';
import Card from "../../../component/Layout/theme/card";
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';

const BusinessOrder = ({ businessPrice, handleResize }) => {

    const navigation = useNavigate();
    var { t } = useTranslation()

    return (
        <>
            <Card className={handleResize} >
                <div className="bg-white w-full py-5 lg:!min-w-[350px] rounded-lg space-y-5 shadow-md ">
                    <div className="space-y-4">
                        <h1 className="font-bold text-base text-center">{t("business")}</h1>

                        <p className="text-center font-medium text-lg">
                            <span className="">{businessPrice && businessPrice.toLocaleString('en-US')}</span>
                            <span>{t("toman")}</span>
                        </p>
                        <p className="font-medium text-sm text-center">{t("yearly")}</p>
                    </div>

                    <div className="flex flex-col gap-3 text-center font-medium text-base">

                        <p className="">{t("no_visit_limit")}</p>

                        <hr className=" " />
                        <p className="" >{t("extendable")}</p>

                        <hr className=" " />
                        <p className="" > {t("ability_multiple_images")}
                        </p>

                        <hr className=" " />
                        <p className="" >{t("hyperlink")} </p>

                    </div>

                    <div className="flex justify-center ">
                        <button
                            onClick={() => navigation('/addOrder/price_business')}
                            className="p-3 font-medium text-sm text-white bg-green-400 rounded-lg w-52">{t("selection")} </button>
                    </div>
                </div>
            </Card>
        </>
    )


}


export default BusinessOrder;